
<script>

  import {
    mapGetters,
    mapActions
  } from "vuex";
  
  import _ from "lodash";

  import { supabase } from "../../libs/supabaseClient";

  import _system from '../../libs/system';
  import iziToast from 'izitoast'
  import 'izitoast/dist/css/iziToast.min.css';

export default {
   name: "trackingCode",
   data() {
      return {
         config: {},
         trackingCodeString: '',
         widget: {
            whatsapp: '',
            instagram: '',
            facebook: '',
         }
      }
   },
   computed: {
   ...mapGetters('session', ['isLoggedIn', 'getUser', 'getWhiteLabel']),
   ...mapGetters("workspaces", ["workspaces", "currentWorkspace", "workspacesByUser"]),
   ...mapGetters('contacts', ['contacts']),
   },
   methods: {
   ...mapActions("session", ["setUser"]),
   ...mapActions("contacts", ["setContacts"]),
   ...mapActions("htmlModals", ["setEditUser"]),
   ...mapActions("loading", ["setLoadingApp", "setLoadingAppReRender"]),
   enable(){
      alert('At present, this feature is undergoing a private beta phase. Access to this feature will be extended to all users in the near future.')
   },
   trackingAction(type){
      if(type == 'disable'){

         this.config.tracking = false;

         supabase.from('widget_config').upsert(this.config, {
                  onConflict: 'ws_id',
                  set: {
                     widget_id: 'excluded.widget_id',
                     wa_url: 'excluded.wa_url',
                     fb_url: 'excluded.fb_url',
                     ig_url: 'excluded.ig_url',
                     tracking: 'excluded.tracking',
                     chat: 'excluded.chat'
                  },
               }).then(result => {});
      }

      if(type == 'enable'){

         this.config.tracking = true;
         supabase.from('widget_config').upsert(this.config, {
                  onConflict: 'ws_id',
                  set: {
                     widget_id: 'excluded.widget_id',
                     wa_url: 'excluded.wa_url',
                     fb_url: 'excluded.fb_url',
                     ig_url: 'excluded.ig_url',
                     tracking: 'excluded.tracking',
                     chat: 'excluded.chat'
                  },
               }).then(result => {});

      }
   },
   chatAction(type){
      if(type == 'disable'){

         this.config.chat = false;

         supabase.from('widget_config').upsert(this.config, {
                  onConflict: 'ws_id',
                  set: {
                     widget_id: 'excluded.widget_id',
                     wa_url: 'excluded.wa_url',
                     fb_url: 'excluded.fb_url',
                     ig_url: 'excluded.ig_url',
                     tracking: 'excluded.tracking',
                     chat: 'excluded.chat'
                  },
               }).then(result => {});
      }
      if(type == 'update'){

         supabase.from('widget_config').upsert(this.config, {
                  onConflict: 'ws_id',
                  set: {
                     widget_id: 'excluded.widget_id',
                     wa_url: 'excluded.wa_url',
                     fb_url: 'excluded.fb_url',
                     ig_url: 'excluded.ig_url',
                     tracking: 'excluded.tracking',
                     chat: 'excluded.chat'
                  },
               }).then(result => {
                  iziToast.success({
                     position: 'bottomCenter',
                     title:  'Widget updated.'
                  });
               });

      }
      if(type == 'enable'){

         this.config.chat = true;
         supabase.from('widget_config').upsert(this.config, {
                  onConflict: 'ws_id',
                  set: {
                     widget_id: 'excluded.widget_id',
                     wa_url: 'excluded.wa_url',
                     fb_url: 'excluded.fb_url',
                     ig_url: 'excluded.ig_url',
                     tracking: 'excluded.tracking',
                     chat: 'excluded.chat'
                  },
               }).then(result => {});

      }
   }
   },
   mounted(){


      if(!localStorage.getItem("juphy_onboarding_tracking")){
         window.Intercom("showArticle", 7873245);
         localStorage.setItem("juphy_onboarding_tracking", "true");
      }


      const timestampzz = (new Date().getTime() / 1000 | 0).toString(16);
      const randomNumber = timestampzz + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => (Math.random() * 16 | 0).toString(16)).toLowerCase();


      
      let widgetObject = [{
               ws_id: this.currentWorkspace._id,
               widget_id: randomNumber,
               tracking: true,
               chat: true,
               wa_url: '',
               fb_url: '',
               ig_url: ''
            }];

      console.log(widgetObject);
      
      supabase.from('widget_config').select('*').eq('ws_id', this.currentWorkspace._id).single().then(widgetConfig => {
         if(!widgetConfig.data){

               supabase.from('widget_config').upsert(widgetObject, {
                  onConflict: 'ws_id',
                  set: {
                     widget_id: 'excluded.widget_id',
                     wa_url: 'excluded.wa_url',
                     fb_url: 'excluded.fb_url',
                     ig_url: 'excluded.ig_url',
                     tracking: 'excluded.tracking',
                     chat: 'excluded.chat'
                  },
               }).then(result => {
                  this.config = widgetObject[0]
               })

         }else{
            console.log(widgetConfig.data)
            this.config = widgetConfig.data
         }
   })

   }
}

</script>

<template>


<div class="ui stackable grid">
<div style="padding-bottom: 0;" class="sixteen wide column">
   <div class="ui basic segment">
      <div style="background: #f1f1f1; border-radius: 1rem; padding: 1rem 2rem;" class="ui basic segment">
         <h5>Copy and paste it inside of your website's head tags.</h5>
         <pre><code>&lt;script src="https://widget.juphy.com/embed/{{config.widget_id}}.js" async&gt;&lt;/script&gt;</code></pre>
      </div>
   </div>
</div>
  <div style="padding-top: 0;" class="sixteen wide column">
   <div class="ui basic segment">
      <div class="ui fluid card">
      <div class="content">
         <div class="header">Conversion Tracking</div>
         <div class="meta">
            <span v-if="config.tracking"> <i class="check teal icon"></i> Active</span>
            <span v-if="!config.tracking"> <i class="minus grey icon"></i> Disabled</span>
         </div>
         <div class="description">

            <p>Our web tracking code is a powerful tool that enables you to monitor and analyze the behavior of your social audience when they visit your website. By activating this feature, you can gain valuable insights into your customers' purchase history and browsing behavior.</p>
<!--             <h4>How does it work?</h4>
            <p>When you send a product link via Juphy on Instagram Direct message, our tracking code will automatically start tracking the user's actions on your website. This means that you'll be able to see whether the user made a purchase, added the product to their cart, or simply browsed your website.</p> -->
         </div>
      </div>
      <div class="extra content">
         <div v-if="config.tracking" @click="trackingAction('disable')" class="ui button">Disable</div>
         <div v-if="!config.tracking" @click="trackingAction('enable')" class="ui blue button">Enable</div>
      </div>
      </div>
    </div>
  </div>
  <div style="background: #ffffff;" class="eight wide column">
   <div class="ui basic segment">
      <div class="ui fluid card">
      <div class="content">
         <div class="header">Social Chat Widget</div>
         <div class="meta">
            <span v-if="config.chat"> <i class="check teal icon"></i> Active</span>
            <span v-if="!config.chat"> <i class="minus grey icon"></i> Disabled</span>
         </div>
         <div class="description">

            <p>Our social chat widget allows you to connect with your customers on popular social media platforms. This means you can easily manage all your customer conversations in one app, without having to switch between different platforms.</p>
<!--             <h4>How does it work?</h4>
            <p>When you send a product link via Juphy on Instagram Direct message, our tracking code will automatically start tracking the user's actions on your website. This means that you'll be able to see whether the user made a purchase, added the product to their cart, or simply browsed your website.</p> -->
         
            <form class="ui form">
               <div class="field">
                  <label>WhatsApp - https://wa.me/phone_number</label>
                  <input type="text" v-model="config.wa_url" placeholder="WhatsApp URL">
               </div>
               <div class="field">
                  <label>Instagram - https://ig.me/m/instagram_username</label>
                  <input type="text" v-model="config.ig_url" placeholder="Instagram URL">
               </div>
               <div class="field">
                  <label>Facebook - https://m.me/facebook_page_username</label>
                  <input type="text" v-model="config.fb_url" placeholder="Facebook URL">
               </div>
            </form>
         
         </div>
      </div>
      <div class="extra content">
         <div v-if="config.chat" @click="chatAction('disable')" class="ui button">Disable</div>
         <div v-if="config.chat" @click="chatAction('update')" class="ui blue button">Update</div>
         <div v-if="!config.chat" @click="chatAction('enable')" class="ui blue button">Enable</div>
      </div>
      </div>
    </div>
  </div>
  <div style="background: #ffffff;" class="eight wide column">
   <div class="ui basic segment">
      <h3 style="margin-top: 0.5rem;">Preview</h3>
      <img style="width: 70%;" src="https://juphy.com/wp-content/uploads/2023/05/preview-juphy.png" alt="">
    </div>
  </div>

</div>

   


</template>


<style scoped>

.ui.card, .ui.cards > .card {
   -webkit-box-shadow: none !important;
   box-shadow: none !important;
}

pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}
.front{
  box-shadow: rgb(224, 224, 224) 0px 2px 4px !important;
  border-radius: 5px !important;
  background: #ffffff !important;
}

.active{
   font-weight:bold !important;
}
.modalWrapper {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   z-index: 9999; 
   overflow: hidden;
}
.modal {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   background: rgba(15, 17, 26, 0.65) none repeat scroll 0% 0%; 
   z-index: 9999; 
   overflow: hidden;
}

.shadow{
   box-shadow: 0px 2px 54px rgba(99, 99, 99, 0.85);
   border: none;
   background: #eee;
}
</style>





// WEBPACK FOOTER //
// src/components/dashboard/trackingCode.vue